var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vendorForm-container" }, [
    _vm.loading
      ? _c("div", [_vm._v("Loading Please wait...")])
      : _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "vendorForm",
                staticClass: "form-container",
                attrs: {
                  model: _vm.vendorForm,
                  rules: _vm.rules,
                  autocomplete: "on",
                  "label-position": "left",
                  size: "mini",
                },
              },
              [
                _c(
                  "sticky",
                  {
                    attrs: {
                      "z-index": 10,
                      "class-name": "sub-navbar",
                      title: _vm.title,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "success" },
                        on: { click: _vm.submitForm },
                      },
                      [_vm._v(" Save ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        attrs: { type: "warning" },
                        on: { click: _vm.cancelForm },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "ca-cards" },
                  [
                    _c("VendorInformation", {
                      staticClass: "ca-card",
                      attrs: { isEdit: _vm.isEdit },
                      model: {
                        value: _vm.vendorForm,
                        callback: function ($$v) {
                          _vm.vendorForm = $$v
                        },
                        expression: "vendorForm",
                      },
                    }),
                    _c("VendorCompany", {
                      staticClass: "ca-card",
                      attrs: { isEdit: _vm.isEdit },
                      model: {
                        value: _vm.vendorCompanyForm,
                        callback: function ($$v) {
                          _vm.vendorCompanyForm = $$v
                        },
                        expression: "vendorCompanyForm",
                      },
                    }),
                    !_vm.isCreate
                      ? _c("VendorLicenses", {
                          staticClass: "ca-card",
                          attrs: { isEdit: _vm.isEdit },
                          model: {
                            value: _vm.vendorForm,
                            callback: function ($$v) {
                              _vm.vendorForm = $$v
                            },
                            expression: "vendorForm",
                          },
                        })
                      : _vm._e(),
                    !_vm.isCreate
                      ? _c("VendorStatus", {
                          staticClass: "ca-card",
                          attrs: { isEdit: _vm.isEdit },
                          model: {
                            value: _vm.vendorForm,
                            callback: function ($$v) {
                              _vm.vendorForm = $$v
                            },
                            expression: "vendorForm",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }